module.exports = __webpack_public_path__ + "static/media/olu-eletu.d9bcce95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/olu-eletu.jpg
// module id = 1257
// module chunks = 0